import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const PrivacyPolicy = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', marginBottom: '30px', borderRadius: '8px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Privacy Policy & Data Protection Statement</h1>
            <p style={{ opacity: 0.9 }}>ARTCARDO, owned and operated by MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART)</p>
            <p style={{ opacity: 0.7, marginTop: '10px' }}>Effective Date: January 2025</p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>1. Introduction</h2>
              <p style={{ color: '#374151', marginBottom: '15px' }}>
                This Privacy Policy and Data Protection Statement ("Policy") describes how MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART), a company incorporated under the Companies Act, 2013 and having its registered office at 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India ("Company", "we", "us", "our"), collects, uses, stores, and protects personal and transactional information of users who access or use the online marketplace ARTCARDO ("Platform").
              </p>
              <p style={{ color: '#374151' }}>
                By accessing or using ARTCARDO, you ("User", "Buyer", "Seller", or "Visitor") consent to the collection and use of your information as described in this Policy. This Policy complies with the Information Technology Act, 2000, the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, the Consumer Protection (E-Commerce) Rules, 2020, and relevant international privacy frameworks such as the EU GDPR (where applicable).
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>2. Information We Collect</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>We may collect the following categories of information:</p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}><strong>Personal Information:</strong> Name, gender, date of birth, contact details, account credentials, identity documents (PAN, GSTIN, bank details).</li>
                <li style={{ marginBottom: '8px' }}><strong>Transactional Information:</strong> Product listings, purchase and sale history, payment details, shipping address, order tracking.</li>
                <li style={{ marginBottom: '8px' }}><strong>Technical Information:</strong> IP address, browser type, device details, cookies, analytics identifiers.</li>
                <li style={{ marginBottom: '8px' }}><strong>Communication Data:</strong> Emails, chat logs, inquiries.</li>
                <li style={{ marginBottom: '8px' }}><strong>International Users:</strong> Data required for customs, international shipping, and foreign exchange compliance under FEMA Act, 1999.</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>3. Purpose of Data Collection</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>We collect and use information for:</p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>Enabling transactions and order fulfillment.</li>
                <li style={{ marginBottom: '8px' }}>Identity verification and fraud prevention.</li>
                <li style={{ marginBottom: '8px' }}>Customer and seller support.</li>
                <li style={{ marginBottom: '8px' }}>Improving platform functionality and user experience.</li>
                <li style={{ marginBottom: '8px' }}>Legal and tax compliance.</li>
                <li style={{ marginBottom: '8px' }}>Communication of updates, offers, or policy changes (where consent is given).</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>4. Consent and User Rights</h2>
              <p style={{ color: '#374151' }}>
                By registering or using ARTCARDO, you consent to the collection, processing, and storage of your information. You have the right to access, correct, or delete your personal data; withdraw consent; and limit processing (where legally permissible). To exercise these rights, contact: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a>
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>5. Cookies and Tracking Technologies</h2>
              <p style={{ color: '#374151' }}>
                We use cookies to maintain sessions, track analytics, and store preferences. You may disable cookies in browser settings, but certain site functions may not work properly if cookies are disabled.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>6. Data Storage, Retention, and Security</h2>
              <p style={{ color: '#374151' }}>
                Data is stored securely within India or in compliant jurisdictions using SSL encryption, access controls, and regular audits. Retention occurs only as long as necessary for business or legal obligations.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>7. Sharing of Information</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}>Information may be shared with:</p>
              <ul style={{ color: '#374151', paddingLeft: '20px', listStyleType: 'disc' }}>
                <li style={{ marginBottom: '8px' }}>Payment gateways and financial institutions.</li>
                <li style={{ marginBottom: '8px' }}>Logistics and shipping partners.</li>
                <li style={{ marginBottom: '8px' }}>Government authorities.</li>
                <li style={{ marginBottom: '8px' }}>Analytics and technology service providers.</li>
              </ul>
              <p style={{ color: '#374151', marginTop: '10px' }}>We do not sell or trade user data for advertising.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>8. International Data Transfers</h2>
              <p style={{ color: '#374151' }}>
                For cross-border transactions, data may be transferred solely for customs, taxation, and payment processing, following applicable laws.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>9. Data Breach and Notification</h2>
              <p style={{ color: '#374151' }}>
                In case of a data breach, ARTCARDO will promptly notify affected users and authorities, outlining remedial measures taken.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>10. Child Privacy and Parental Consent</h2>
              <p style={{ color: '#374151' }}>
                ARTCARDO is for users above 18. We do not knowingly collect data from minors. Parents may contact <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a> to request deletion of such data.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>11. Third-Party Links and Services</h2>
              <p style={{ color: '#374151' }}>
                Our platform may link to third-party websites (e.g., payment gateways). We are not responsible for their privacy practices and recommend reviewing their policies.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>12. User Account Management and Deletion</h2>
              <p style={{ color: '#374151' }}>
                Users may request account deletion via <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a>. Data will be deleted within 30 working days, subject to legal retention requirements.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>13. Grievance Redressal</h2>
              <p style={{ color: '#374151', marginBottom: '10px' }}><strong>Grievance Officer / Data Protection Officer</strong></p>
              <p style={{ color: '#374151' }}>Company: MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART)</p>
              <p style={{ color: '#374151' }}>Name: [To be Appointed]</p>
              <p style={{ color: '#374151' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
              <p style={{ color: '#374151' }}>Phone: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              <p style={{ color: '#374151' }}>Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
              <p style={{ color: '#374151' }}>Response Time: Within 15 business days</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>14. Updates to This Policy</h2>
              <p style={{ color: '#374151' }}>
                This Policy may be updated periodically. Revised versions will be posted on our website with an updated 'Last Revised' date.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>15. Governing Law and Jurisdiction</h2>
              <p style={{ color: '#374151' }}>
                This Policy is governed by Indian law. Disputes shall be under the exclusive jurisdiction of Bangalore, Karnataka courts.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>16. Contact Information</h2>
              <p style={{ color: '#374151' }}>For any questions, contact:</p>
              <p style={{ color: '#374151' }}><strong>MAXRAD SOFTWARE INDIA PVT LTD</strong></p>
              <p style={{ color: '#374151' }}>(Brand name ARTCARDO under the division DULCIA.ART)</p>
              <p style={{ color: '#374151' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
              <p style={{ color: '#374151' }}>Phone: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              <p style={{ color: '#374151' }}>Website: www.artcardo.com</p>
              <p style={{ color: '#374151' }}>Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
